// extracted by mini-css-extract-plugin
module.exports = {"card":"flashcard_card__2QQRD","image":"flashcard_image__1Fuk9","text":"flashcard_text__JjWN0"};